/* eslint-disable @typescript-eslint/no-unused-vars */
// import Card from "./components/Card";
import * as Styles from "./style";

interface Props {
  data: any;
}

const Body = (props: Props) => {
  return (
    <>
      <Styles.ProductsContainer>
        {/* <Styles.ButtonContainer>
          <Styles.Button>Espelho de vendas</Styles.Button>
          <Styles.ButtonTabelas>Tabela de vendas</Styles.ButtonTabelas>
        </Styles.ButtonContainer>
        <Styles.CardsContainer>
           {props?.data?.supervisor?.map((item: any) => (
            <>
              {item?.nome ? (
                <>
                  <Card
                    nome={item?.nome}
                    cargo="supervisor"
                    whatsapp={item?.celular}
                    email={item?.email}
                    urlFoto={item?.urlFoto}
                  />
                </>
              ) : (
                <></>
              )}
            </>
          ))}
      </Styles.CardsContainer> */}
      </Styles.ProductsContainer>
    </>
  );
};

export default Body;
